export const BUNDLE_TAB_PANEL_BG = '#FAF7F4';
